/** Task 2 (Freelo #32253593): double-clicking a grid column header's resize handle auto-fits it to
 * its longest currently visible value. Pure and measure-agnostic (the caller supplies `measure`,
 * normally a canvas 2D context's `measureText(...).width`) so it stays trivially testable — see
 * `column-autofit.test.ts`, which fakes `measure` with a fixed px-per-character function. */
export const autoFitWidth = (
  texts: string[],
  measure: (s: string) => number,
  opts: { padding: number; min: number; max: number },
): number => {
  if (texts.length === 0) return opts.min
  const widest = texts.reduce((max, s) => Math.max(max, measure(s)), 0)
  return Math.min(opts.max, Math.max(opts.min, Math.round(widest + opts.padding)))
}
